import { getEditor, isEnabled } from '../composables/editorsMap';
import LinkOptions from '../menuItemComponents/LinkOptions.vue';
import { Link2 } from 'lucide-vue-next';
export const getLinkOptions = (id: string) => {
  const editor = getEditor(id)?.value;

  return {
    disabled: !isEnabled(id, 'link'),
    icon: Link2,
    title: 'קישור',
    type: 'select',
    loseFocus: true,
    component: LinkOptions,
    props: {},
    action: href => {
      if (href)
        getEditor(id)
          .value.chain()
          .focus()
          .setLink({ href, class: 'href' })
          .run();
      else {
        editor?.chain().focus().unsetLink().run();
      }
    },
    isActive: () => editor?.isActive('link'),
  };
};
